import axios from "axios";
import type { AxiosPromise, AxiosRequestConfig } from "axios";

const baseApiURL = import.meta.env.REACT_APP_BASE_API;

function urlCreator(url: string) {
  return `${baseApiURL}/${url}`;
}

export const getData = (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosPromise> => {
  url = url
    .split("/")
    .filter((el) => el != "")
    .join("/");
  return axios.get(urlCreator(url), config);
};

export const postData = (
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<AxiosPromise> => {
  url = url
    .split("/")
    .filter((el) => el != "")
    .join("/");
  return axios.post(urlCreator(url), data, config);
};

export const putData = (
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<AxiosPromise> => {
  url = url
    .split("/")
    .filter((el) => el != "")
    .join("/");
  return axios.put(urlCreator(url), data, config);
};

export const deleteData = (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosPromise> => {
  url = url
    .split("/")
    .filter((el) => el != "")
    .join("/");
  return axios.delete(urlCreator(url), config);
};
